import Select from 'react-select'
import { ReactComponent as SelectDown } from 'assets/common/selectDown.svg'
import { GlobalContext } from 'App';
import { useContext } from 'react';

interface ICustomSelect {
    className?: string;
    option: ISelectOption[]
    placeholder: string;
    defaultValue?: ISelectOption;
    value?: ISelectOption | null;
    onChange?: (value: string, allData: ISelectOption) => void;
    onInputChange?: (value: string) => void;
    setSelected?: React.Dispatch<React.SetStateAction<ISelectOption>>
    border?: boolean
    isSearchable?: boolean
    isFull?: boolean
    disabled?: boolean
    isWhite?: boolean
    width?: string
    height?: number
    fontSize?: number
    textColor?: string
    position?: 'top' | 'auto' | 'bottom'
}

export interface ISelectOption {
    value: string,
    label: string,
    labelEn?: string
    country?: string
    portName?: string
    type?: string
    x?: number
    y?: number
    z?: number
    weight?: number
    color?: string
    require?: string
}

const CustomSelect = ({
    className,
    option,
    defaultValue,
    value,
    placeholder,
    setSelected,
    onChange,
    onInputChange,
    border = true,
    isWhite = true,
    isSearchable = true,
    isFull = true,
    disabled,
    width,
    height = 60,
    fontSize = 16,
    textColor,
    position
}: ICustomSelect) => {
    const { isTablet } = useContext(GlobalContext);

    return (
        <div className={isFull ? `w-full` : `${width}`}>
            {
                option.length > 0 &&
                <Select
                    menuPlacement={position}
                    className={className}
                    defaultValue={defaultValue}
                    value={value}
                    isDisabled={disabled}
                    placeholder={placeholder}
                    isSearchable={isSearchable}
                    components={{
                        IndicatorSeparator: () => null,
                        DropdownIndicator: () => <SelectDown />
                    }}
                    onChange={(e) => {
                        const data = e as ISelectOption
                        setSelected?.(data)
                        onChange?.(data.value, data);
                    }}
                    onInputChange={(value) => {
                        onInputChange?.(value)
                    }}
                    noOptionsMessage={() => '데이터가 없습니다.'}
                    options={option}
                    styles={{
                        menuList: (provided) => ({
                            ...provided,
                            backgroundColor: isWhite ? 'white' : '#F8F8FA',
                        }),
                        control: (baseStyles) => ({
                            ...baseStyles,
                            backgroundColor: isWhite ? 'white' : '#F8F8FA',
                            borderRadius: '0.5rem',
                            height: `${isTablet ? 40 : height}px`,
                            padding: isTablet ? '0 8px' : '0 16px',
                            borderColor: border ? '#9D9EB7' : 'transparent',
                            fontSize: isTablet ? 14 : fontSize
                        }),
                        option: (baseStyles, state) => ({
                            ...baseStyles,
                            backgroundColor: state.isSelected ? '#196BFF' : (state.isFocused ? '#575A7A' : '#F8F8FA'),
                            color: state.isSelected ? 'white' : (state.isFocused ? '#F8F8FA' : '#9D9EB7'),
                            fontSize: isTablet ? 14 : fontSize
                        }),
                        placeholder: (base, props) => ({
                            ...base,
                            color: '#B5B5B5',
                        }),
                        singleValue: (provided) => ({
                            ...provided,
                            color: textColor ? textColor : 'black',
                            padding: 0
                        }),
                        input: (base) => ({
                            ...base,
                            color: 'black',
                        }),
                    }}
                />
            }
        </div>
    );
}

export default CustomSelect;